/** zh-CN catalogue `onboarding` (W3-09; English: src/features/onboarding/onboarding.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'onboarding',
  locale: 'zh-CN',
  messages: {
    frTitle: '欢迎使用 Phiedit',
    frIntro: 'Phiedit 用于为 Phira 制作谱面。你想从哪里开始？',
    frChoicesLabel: '你的经验',
    frNew: '我是制谱新手',
    frNewBody: '引导模式 · 通俗提示 · 2 分钟导览',
    frRpe: '我用过 RPE（Re:PhiEdit）',
    frRpeBody: '完整模式 · RPE 键位 · “RPE 用户指南”',
    frOther: '我用过其他编辑器（osu!、Phichain 等）',
    frOtherBody: '完整模式 · 默认键位',
    frLanguage: '语言',
    langEn: 'English',
    langZh: '简体中文',
    frLater: '以上所有选项之后都可以在“设置”中更改。',
    frContinue: '继续',
    tourStep: '第 {n} 步，共 {total} 步',
    tourNext: '下一步',
    tourBack: '上一步',
    tourFirstStep: '这是第一步。',
    tourFinish: '完成',
    tourSkip: '跳过导览',
    tourClose: '关闭导览',
    tourDoneStep: '很好，成功了。',
    tourAnnounce: '{label}：{title}',
    tourNotOnScreen: '这一部分现在不在屏幕上；它出现后导览会继续。',
    tourNeedsChartTitle: '导览需要在谱面中进行',
    tourNeedsChartBody: '打开示例谱面并在其中进行导览？',
    tourOpenSample: '打开示例',
    tourFinished:
      '导览已完成。{help, select, none {可以从“帮助”菜单再次进行导览。} other {可以从“帮助”（{help}）再次进行导览。}}',
    tourLineTitle: '这是你的判定线',
    tourLineBody: '音符会落到判定线上。预览显示的正是 Phira 将会播放的内容；它处于编辑模式，可以单击并拖动判定线。',
    tourPlayTitle: '播放曲目',
    tourPlayBody:
      '{play, select, none {单击此按钮播放和暂停。} other {按 {play} 或单击此按钮播放和暂停。}}{listen, select, none {} other {按住 {listen} 可只在按键按下时试听。}}',
    tourTapTitle: '放置一个 Tap',
    tourTapBody:
      '{tool, select, none {选择 Tap 工具} other {选择 Tap 工具（{tool}）}}，然后在轨道中单击{place, select, none {。} other {，或将鼠标移到轨道上按 {place}。}}',
    tourHoldTitle: '放置一个 Hold',
    tourHoldBody:
      '{tool, select, none {选择 Hold 工具，} other {选择 Hold 工具（{tool}），}}在 Hold 开始处按下，向上拖动到结束处。',
    tourDragTitle: '让判定线动起来',
    tourCurveTitle: '改变运动方式',
    tourCurveBody:
      '在运动列中单击两个关键帧之间的区段，然后{curve, select, none {右键单击它} other {按 {curve}}}来选择缓动，例如“慢停”。',
    tourProblemsTitle: '留意“问题”',
    tourProblemsBody: '这个标签统计问题数量。单击它可以用通俗的语言逐一查看问题，大多数都带有“修复”按钮。',
    tourProblemsBodyMore:
      '在这个大小的窗口中，问题数量位于“更多”菜单中。打开它并单击数量，即可用通俗的语言逐一查看问题，大多数都带有“修复”按钮。',
    tourPublishTitle: '发布',
    tourPublishBody:
      '准备就绪后，打开“发布”{publish, select, none {} other {（{publish}）}}：它会检查谱面并导出一个 .pez 文件，Phira 播放它的效果与预览完全一致。',
    sampleTitle: 'Phiedit 示例',
    sampleIntro: '一张基于合成鼓点循环的短谱面，展示了所有判定线类型、层级和一条 UI 绑定线。',
    sampleCredit: 'Phiedit',
    sampleLineMain: '主线',
    sampleLinePartner: '搭档',
    sampleLineTitle: '标题',
    sampleLinePicture: '图片',
    sampleLineSpinner: '旋转线',
    sampleLineBrush: '画笔',
    sampleLineScore: '分数绑定',
    sampleWordsFirst: '用示例来学习',
    sampleWordsSecond: '享受制谱的乐趣',
    samplePreparing: '正在准备示例谱面…',
    sampleFailed: '无法创建示例谱面：{detail}',
    sampleExistsTitle: '打开示例谱面',
    sampleExistsBody: '谱面库中已经有示例谱面了。',
    sampleOpenExisting: '打开我的示例',
    sampleOpenExistingBody: '从上次离开的地方继续。',
    sampleFresh: '新建一份副本',
    sampleFreshBody: '在你的示例旁边新建一份未改动的示例。',
    cmdSampleOpen: '用示例来学习',
    cmdTourStart: '开始导览',
    cmdTourStop: '结束导览',
    cmdHelpOpen: '帮助',
    cmdHelpRpe: '帮助：RPE 用户指南',
    cmdHelpGlossary: '帮助：Phiedit 中的术语',
    cmdHelpWelcome: '再次显示欢迎问题',
    cmdHelpShowMe: '帮助：演示给我看',
    argTopic: '帮助主题',
    tourNotRunning: '当前没有正在进行的导览。',
    showMeUnknown: '没有名为“{topic}”的帮助主题。',
    welcomeApplied: '已应用你的选择。',
  },
};

export default catalog;
